<template>
  <div class="card-attributes block-card card-border">
    <v-expansion-panel :value="panel" expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header>
          <div class="block-card-title handle">
            <div class="title-icon">
              <span class="botter-bracket-icon white--text text-lg-2" />
            </div>

            <h4>
              Setup User Attribute
              <v-icon
                v-if="errorsCount && errorsCount.errorsCount"
                color="error"
                style="margin-left: 4px"
                >error</v-icon
              >
              <span class="text--error" v-if="!validData"
                >(Invalid Card Data)</span
              >
            </h4>
          </div>
        </template>
        <form-validation v-model="errorsCount">
          <div class="block-card-body" v-if="validData">
            <p>
              Set a value for an existing user attribute or add a new one. Use
              it to segment users for campaign subscriptions, to define bot flow
              scenarios, or to analyze users' activity. Note that you can use
              arithmetic expressions and attributes in the Value field.
            </p>
            <div
              v-for="(attribute, index) in data.attributes"
              class="attributes-list delete-wrapper"
              :key="index"
            >
              <v-layout row wrap>
                <v-flex xs6>
                  <label>Attribute</label>
                  <v-text-field
                    v-model="attribute.attribute"
                    :error="!attribute.attribute"
                    :error-messages="
                      !attribute.attribute ? 'Attribute is Required' : ''
                    "
                    outline
                  />
                </v-flex>
                <v-flex xs6>
                  <label>Value</label>
                  <v-text-field
                    v-model="attribute.value"
                    :error="!attribute.value"
                    :error-messages="
                      !attribute.value ? 'Attribute Value is Required' : ''
                    "
                    outline
                  />
                </v-flex>
              </v-layout>
              <v-btn
                fab
                small
                color=""
                class="delete-button"
                @click="deleteAttribute(index)"
                ><v-icon small color="#666">delete_outline</v-icon></v-btn
              >
            </div>
            <v-btn
              large
              round
              flat
              block
              class="primary--text"
              @click="addAttribute"
            >
              <v-icon>add_circle_outline</v-icon>
              Add New User Attribute
            </v-btn>
          </div>
        </form-validation>
        <slot name="tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from "../../../../utils/common";
import FormValidation from "../FormValidation";
export default {
  name: "CardAudio",
  components: {
    FormValidation,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    blocksList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    validData: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      valid: true,
      panel: 1,
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      common,
    };
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit("input", { errorsCount: val.errorsCount });
      this.data.errorsCount = val.errorsCount;
    },
    data: {
      async handler() {
        await this.getVariables();
      },
      deep: true,
    },
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount;
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false;
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true;
      }, 1000);
    }
  },
  methods: {
    addAttribute() {
      this.data.attributes.push({
        id: 0,
        attribute: "",
        value: "",
      });
    },
    deleteAttribute(index) {
      this.data.attributes.splice(index, 1);
    },
    async getVariables() {
      const response = await this.$http_bot.get("/blocks/variables/available");

      const variables = [];
      for (let i = 0; i < response.data.length; i++) {
        if (response.data[i].variable !== "") {
          variables.push(response.data[i]);
        }
      }
      variables.push("channel");
      this.$store.dispatch("setVariables", variables);
    },
  },
};
</script>

<style scoped></style>
